module.exports = __webpack_public_path__ + "static/ClickedOverseas-d65c10b058fae4673922e45ab0f956e1.png";